import { useSystemAuthState } from "auth/SystemAuth/context/context";
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  
  const authState = useSystemAuthState();

  return (
    <div className="customErrorWrapper">
      <div className="pageNotFound"></div>
      {authState.user && <div className="goBackLink">
        Go back to <Link to="/home">Home</Link>
      </div>}
    </div>
  );
};

export default NotFound;
